import { bool, func, number, string } from "prop-types";
import classes from "./RadioInput.module.scss";
import classNames from "classnames";
import PropTypes from "prop-types";

const RadioInput = (props) => {
  return (
    <span className="radio-input">
      <input
        type="radio"
        id={props.id}
        name={props.name}
        value={props.value}
        checked={props.checked}
        onChange={props.onChange}
        className="radio-input"
        disabled={props.disabled}
      />
      <label className="radio-label" htmlFor={props.id}>
        <span className="radio-label-text">{props.label}</span>
        <span className="radio-option"></span>
        {props.addInfo && (
          <span className={classNames(classes.sideInfo)}>{props.addInfo}</span>
        )}
      </label>
    </span>
  );
};

RadioInput.propTypes = {
  id: PropTypes.string,
  name: PropTypes.string,
  value: PropTypes.string,
  checked: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  addInfo: PropTypes.string,
  disabled: PropTypes.bool,
};

export default RadioInput;
